import { UserModule } from '../store/modules/user';
import { OrderType, Type, ViewType, ModuleType } from '@/types/permissionType';

export function checkPermissionUseAndCompany(companyId: string, permission: Type) {
  var moduleBeanCompany = getModuleUserOrCompany(companyId);
  var moduleBeanRole = getModuleUserOrRole(companyId);
  if (moduleBeanCompany === null || moduleBeanRole === null) {
    return false;
  } else {
    return checkPermissionDetail(moduleBeanCompany, moduleBeanRole, permission);
  }
}

export function checkPermissionCompany(companyId: string, permission: Type) {
  var moduleBeanCompany = getModuleUserOrCompany(companyId);
  if (moduleBeanCompany) {
    return checkPermissionSingDetail(moduleBeanCompany, permission);
  } else {
    return false;
  }
}

export function checkPermissionRole(companyId: string, permission: Type) {
  var moduleBeanCompany = getModuleUserOrRole(companyId);
  if (moduleBeanCompany) {
    return checkPermissionSingDetail(moduleBeanCompany, permission);
  } else {
    return false;
  }
}

export function checkPermissionCompanyFromOrderType(companyId: string, permission: Type, orderType: any) {
  var r: boolean = false;
  switch (parseInt(orderType)) {
    case 1:
      r = checkPermissionSingDetail(getOtherModule(companyId), permission);
      break;
    case 2:
      r = checkPermissionSingDetail(getFixModule(companyId), permission);
      break;
    case 3:
      r = checkPermissionSingDetail(getInstallModule(companyId), permission);
      break;
    case 4:
      r = checkPermissionSingDetail(getPollingModule(companyId), permission);
      break;
  }
  return r;
}

export function addOrderServerIsHave(permission: Type, orderType: any, selcetServicer:any) {
  let have = false;
  let servicer: any = ''
  if (selcetServicer) {
    servicer = selcetServicer
  } else {
    servicer = UserModule.getCompany;
  }
  let myModule: any = null;
  switch (parseInt(orderType)) {
    case OrderType.FixModule:
      myModule = servicer.fix_module;
      break;
    case OrderType.InstallModule:
      myModule = servicer.install_module;
      break;
    case OrderType.OtherModule:
      myModule = servicer.other_module;
      break;
    case OrderType.CheckModule:
      myModule = servicer.check_module;
      break;
  }
  if (myModule) {
    let cusDept = myModule.ls941000;
    let photoLs = myModule.ls960000;
    let soundLs = myModule.ls950000;
    let videoLs = myModule.ls970000;
    let tagLs = myModule.ls603000;
    let pcaLs = myModule.ls990000;
    let deptLs = myModule.ls940000;
    let productLs = myModule.ls301000;
    let faultLs = myModule.ls750000;
    let faultPhenomenonLs = myModule.ls615000;
    let deviceLs = myModule.ls302000;
    let timeLs = myModule.ls930000;
    let myselfPCALs = myModule.ls920000;
    let priceLs = myModule.ls500000;
    let partsLs = myModule.ls350000;
    let remarkLs = myModule.ls980000;
    let addressLs = myModule.ls891000;

    let contentUserLs = myModule.ls893100;
    let contentUserMobileLs = myModule.ls893200;
    let contentUserPhoneLs = myModule.ls893300;
    let DescriptionLs = myModule.ls892000;
    let SNLs = myModule.ls897100;
    let diyOneLs = myModule.ls895100;
    let diyWtoLs = myModule.ls895200;
    let wordFileLs = myModule.ls894100;

    let installOrderSource = myModule.ls896100;
    let installOrderNum = myModule.ls896200;
    let installOrderAppointment = myModule.ls896300;

    let lsBean: any = {};
    switch (permission) {
      case Type.CUS_DEPT:
        if (cusDept) {
          lsBean = cusDept;
        }
        break
      case Type.photo:
        if (photoLs) {
          lsBean = photoLs;
        }
        break;
      case Type.sound:
        if (soundLs) {
          lsBean = soundLs;
        }
        break;
      case Type.video:
        if (soundLs) {
          lsBean = videoLs;
        }
        break;
      case Type.tag:
        if (tagLs) {
          lsBean = tagLs;
        }
        break;
      case Type.pca:
        if (pcaLs) {
          lsBean = pcaLs;
        }
        break;
      case Type.address:
        if (addressLs) {
          lsBean = addressLs;
        }
        break;
      case Type.dept:
        if (deptLs) {
          lsBean = deptLs;
        }
        break;
      case Type.product:
        if (productLs) {
          lsBean = productLs;
        }
        break;
      case Type.fault:
        if (faultLs) {
          lsBean = faultLs;
        }
        break;
      case Type.FAULT_PHENOMENON:
        if (faultPhenomenonLs) {
          lsBean = faultPhenomenonLs;
        }
        break;
      case Type.device:
        if (deviceLs) {
          lsBean = deviceLs;
        }
        break;
      case Type.time:
        if (timeLs) {
          lsBean = timeLs;
        }
        break;
      case Type.myselfPCALs:
        if (myselfPCALs) {
          lsBean = myselfPCALs;
        }
        break;
      case Type.price:
        if (myselfPCALs) {
          lsBean = priceLs;
        }
        break;
      case Type.parts:
        if (partsLs) {
          lsBean = partsLs;
        }
        break;
      case Type.remark:
        if (remarkLs) {
          lsBean = remarkLs;
        }
        break;
      case Type.contentUser:
        if (contentUserLs) {
          lsBean = contentUserLs;
        }
        break;
      case Type.contentUserMobile:
        if (contentUserMobileLs) {
          lsBean = contentUserMobileLs;
        }
        break;
      case Type.contentUserPhone:
        if (contentUserPhoneLs) {
          lsBean = contentUserPhoneLs;
        }
        break;
      case Type.Description:
        if (DescriptionLs) {
          lsBean = DescriptionLs;
        }
        break;
      case Type.SN:
        if (SNLs) {
          lsBean = SNLs;
        }
        break;
      case Type.DiyOne:
        if (diyOneLs) {
          lsBean = diyOneLs;
        }
        break;
      case Type.DiyTwo:
        if (diyWtoLs) {
          lsBean = diyWtoLs;
        }
        break;
      case Type.WordFile:
        if (wordFileLs) {
          lsBean = wordFileLs;
        }
        break;
      case Type.InstallOrderSource:
        if (installOrderSource) {
          lsBean = installOrderSource;
        }
        break
      case Type.InstallOrderNum:
        if (installOrderNum) {
          lsBean = installOrderNum;
        }
        break
      case Type.InstallOrderAppointment:
        if (installOrderAppointment) {
          lsBean = installOrderAppointment;
        }
        break
      default:
        break;
    }
    if (lsBean) {
      // 选择的服务方就是我要报修 判断order_config
      if (selcetServicer) {
        have = (parseInt(lsBean.have) === 1) && (parseInt(lsBean.order_config) !== 9) && (parseInt(lsBean.order_config) !== 0);
      } else {
        have = (parseInt(lsBean.have) === 1) && (parseInt(lsBean.add_order_config) !== 9) && (parseInt(lsBean.add_order_config) !== 0);
      }
    }
  }
  return have;
}

//此方法 目前只在OrderAdd.vue上有
export function addOrderNotShow(permission: Type, orderType: any, selcetServicer:any) {
  let notShow = false;
  let servicer: any = ''
  if (selcetServicer) {
    servicer = selcetServicer
  } else {
    servicer = UserModule.getCompany;
  }
  let myModule: any = null;
  switch (parseInt(orderType)) {
    case OrderType.FixModule:
      myModule = servicer.fix_module;
      break;
    case OrderType.InstallModule:
      myModule = servicer.install_module;
      break;
    case OrderType.OtherModule:
      myModule = servicer.other_module;
      break;
    case OrderType.CheckModule:
      myModule = servicer.check_module;
      break;
  }
  if (myModule) {

    let cusDept = myModule.ls941000;

    let lsBean: any = {};
    switch (permission) {
      case Type.CUS_DEPT:
        if (cusDept) {
          lsBean = cusDept;
        }
        break
      default:
        break;
    }
    if (lsBean) {
      // 选择的服务方就是我要报修 判断order_config 无模板或者禁用 不显示
      if (selcetServicer) {
        notShow = (parseInt(lsBean.have) === 0) || ( (parseInt(lsBean.have) === 1) && (parseInt(lsBean.order_config) == 9)  );
      } else {
        notShow = (parseInt(lsBean.have) === 0) || ( (parseInt(lsBean.have) === 1) && (parseInt(lsBean.add_order_config) == 9) );
      }
    }
  }
  return notShow;
}

export function addOrderServerIsMust(permission: Type, orderType: any, selcetServicer:any) {
  let must = false;
  let servicer: any = ''
  if (selcetServicer) {
    servicer = selcetServicer
  } else {
    servicer = UserModule.getCompany;
  }
  let myModule: any = null;
  switch (parseInt(orderType)) {
    case OrderType.FixModule:
      myModule = servicer.fix_module;
      break;
    case OrderType.InstallModule:
      myModule = servicer.install_module;
      break;
    case OrderType.OtherModule:
      myModule = servicer.other_module;
      break;
    case OrderType.CheckModule:
      myModule = servicer.check_module;
      break;
  }
  if (myModule && myModule !== null) {
    let photoLs = myModule.ls960000;
    let soundLs = myModule.ls950000;
    let videoLs = myModule.ls970000;
    let tagLs = myModule.ls603000;
    let pcaLs = myModule.ls990000;
    let deptLs = myModule.ls940000;
    let productLs = myModule.ls301000;
    let faultLs = myModule.ls750000;
    let faultPhenomenonLs = myModule.ls615000;
    let deviceLs = myModule.ls302000;
    let timeLs = myModule.ls930000;
    let myselfPCALs = myModule.ls920000;
    let priceLs = myModule.ls500000;
    let partsLs = myModule.ls350000;
    let remarkLs = myModule.ls980000;
    let addressLs = myModule.ls891000;

    let contentUserLs = myModule.ls893100;
    let contentUserMobileLs = myModule.ls893200;
    let contentUserPhoneLs = myModule.ls893300;
    let DescriptionLs = myModule.ls892000;
    let SNLs = myModule.ls897100;
    let diyOneLs = myModule.ls895100;
    let diyWtoLs = myModule.ls895200;
    let wordFileLs = myModule.ls894100;

    let installOrderSource = myModule.ls896100;
    let installOrderNum = myModule.ls896200;
    let installOrderAppointment = myModule.ls896300;

    let cusDept = myModule.ls941000;


    let lsBean: any = {};
    switch (permission) {
      case Type.photo:
        if (photoLs) {
          lsBean = photoLs;
        }
        break;
      case Type.sound:
        if (soundLs) {
          lsBean = soundLs;
        }
        break;
      case Type.video:
        if (soundLs) {
          lsBean = videoLs;
        }
        break;
      case Type.tag:
        if (tagLs) {
          lsBean = tagLs;
        }
        break;
      case Type.pca:
        if (pcaLs) {
          lsBean = pcaLs;
        }
        break;
      case Type.address:
        if (addressLs) {
          lsBean = addressLs;
        }
        break;
      case Type.dept:
        if (deptLs) {
          lsBean = deptLs;
        }
        break;
      case Type.product:
        if (productLs) {
          lsBean = productLs;
        }
        break;
      case Type.fault:
        if (faultLs) {
          lsBean = faultLs;
        }
        break;
      case Type.FAULT_PHENOMENON:
        if (faultPhenomenonLs) {
          lsBean = faultPhenomenonLs;
        }
        break;
      case Type.device:
        if (deviceLs) {
          lsBean = deviceLs;
        }
        break;
      case Type.time:
        if (timeLs) {
          lsBean = timeLs;
        }
        break;
      case Type.myselfPCALs:
        if (myselfPCALs) {
          lsBean = myselfPCALs;
        }
        break;
      case Type.price:
        if (myselfPCALs) {
          lsBean = priceLs;
        }
        break;
      case Type.parts:
        if (partsLs) {
          lsBean = partsLs;
        }
        break;
      case Type.remark:
        if (remarkLs) {
          lsBean = remarkLs;
        }
        break;
      case Type.contentUser:
        if (contentUserLs) {
          lsBean = contentUserLs;
        }
        break;
      case Type.contentUserMobile:
        if (contentUserMobileLs) {
          lsBean = contentUserMobileLs;
        }
        break;
      case Type.contentUserPhone:
        if (contentUserPhoneLs) {
          lsBean = contentUserPhoneLs;
        }
        break;
      case Type.Description:
        if (DescriptionLs) {
          lsBean = DescriptionLs;
        }
        break;
      case Type.SN:
        if (SNLs) {
          lsBean = SNLs;
        }
        break;
      case Type.DiyOne:
        if (diyOneLs) {
          lsBean = diyOneLs;
        }
        break;
      case Type.DiyTwo:
        if (diyWtoLs) {
          lsBean = diyWtoLs;
        }
        break;
      case Type.WordFile:
        if (wordFileLs) {
          lsBean = wordFileLs;
        }
        break;
      case Type.InstallOrderSource:
        if (installOrderSource) {
          lsBean = installOrderSource;
        }
        break
      case Type.InstallOrderNum:
        if (installOrderNum) {
          lsBean = installOrderNum;
        }
        break
      case Type.InstallOrderAppointment:
        if (installOrderAppointment) {
          lsBean = installOrderAppointment;
        }
        break
      case Type.CUS_DEPT:
        if (cusDept) {
          lsBean = cusDept;
        }
        break
      default:
        break;
    }
    if (lsBean) {
      // 选择的服务方就是我要报修 判断order_config
      if (selcetServicer) {
        must = parseInt(lsBean.order_config) === 2;
      } else {
        must = parseInt(lsBean.add_order_config) === 2;
      }
    }
  }
  return must;
}
// 公司Module判断
export function checkPermissionCompanyModule(companyId: string, permission: Type) {
  var moduleBeanCompany = getModuleUserOrCompany(companyId);
  if (moduleBeanCompany) {
    return checkPermissionSingDetail(moduleBeanCompany, permission);
  } else {
    return false;
  }
}
// 模块的权限判断
export function getModelPermission(viewtype: ViewType, orderType: any, dealType: any, companyId: any, permission: ModuleType) {
  return getModelPermissionAndName(viewtype, orderType, dealType, companyId, permission, null);
}

/**
 * utils/permission.ts
 * 模块的权限判断
 * getModelPermission //没有重命名字段
 * getModelPermissionAndName //有重命名字段
 * @param viewtype 页面信息
 * @param orderType 订单类型
 * @param dealType 处理类型 未启用
 * @param companyId 公司id
 * @param permission model的特殊权限
 * @param temp 重命名字段
 * 返回值
 * var ViewModel = {
 *  v: -1, // view显示否
 *  m: -1, // 是否是必填
 *  me: '', // 必填错误提示信息
 *  av: -1, // 添加按钮是否显示
 *  dv: -1 // 删除按钮是否显示
 *};
 */
export function getModelPermissionAndName(viewtype: ViewType, orderType: any, dealType: any, companyId: any, permission: ModuleType, temp: any) {
  var ViewModel = {
    v: -1, // view显示否
    m: -1, // 是否是必填
    me: '', // 必填错误提示信息
    av: -1, // 添加按钮是否显示
    dv: -1 // 删除按钮是否显示
  };
  // 根据订单类型获取view的权限Model
  var baseModuleBean = null;
  switch (parseInt(orderType)) {
    // 其他
    case 1:
      baseModuleBean = getOtherBaseModel(companyId, permission);
      break;
    // 维保
    case 2:
      baseModuleBean = getFixBaseModel(companyId, permission);
      break;
    // 安装
    case 3:
      baseModuleBean = getInstallBaseModel(companyId, permission);
      break;
    case 4:
      baseModuleBean = getPollingBaseModel(companyId, permission);
      break;
    default:
      break;
  }

  // 根据页面 获取必填判断
  switch (viewtype) {
    case ViewType.REPORT:
      ViewModel.m = (baseModuleBean != null && parseInt(baseModuleBean.order_config) === 2 ? 1 : 0);
      break;
    case ViewType.REPORT_ADD:
      ViewModel.m = (baseModuleBean != null && parseInt(baseModuleBean.add_order_config) === 2 ? 1 : 0);
      break;
    case ViewType.DEAL_ORDER:
    case ViewType.DEAL_INSPECTION_ORDER:
      if (permission !== ModuleType.ORDER_VIDEO &&
        permission !== ModuleType.ORDER_AUDIO &&
        permission !== ModuleType.ORDER_IMAGE) {
        ViewModel.m = (baseModuleBean != null && parseInt(baseModuleBean.fix_config) === 2 ? 1 : 0);
      }
      break;
    case ViewType.DEAL_TASK:
    case ViewType.DEAL_INSPECTION_TASK:
      if (permission !== ModuleType.ORDER_VIDEO &&
        permission !== ModuleType.ORDER_AUDIO &&
        permission !== ModuleType.ORDER_IMAGE) {
        ViewModel.m = (baseModuleBean != null && parseInt(baseModuleBean.task_config) === 2 ? 1 : 0);
      }
      break;
    case ViewType.DETAIL_ORDER:
    case ViewType.DETAIL_TASK:
      break;
  }

  // 根据view获取必填报错信息
  var msg = '';
  var addVisble = -1;
  var delVisble = -1;
  var visible = -1;
  visible = checkVisibility(baseModuleBean, viewtype);
  switch (permission) {
    case ModuleType.ORDER_WORD_FILE:
      if (temp != null) {
        msg = '请添加' + temp;
      } else {
        msg = '请添加文档';
      }
      break;
    case ModuleType.ORDER_IMAGE:
      if (temp != null) {
        msg = '请添加' + temp;
      } else {
        msg = '请添加图片';
      }
      break;
    case ModuleType.ORDER_VIDEO:
    case ModuleType.ORDER_DEAL_VIDEO:
      msg = '请添加视频';
      break;
    case ModuleType.ORDER_AUDIO:
      msg = '请添加录音';
      break;
    case ModuleType.ORDER_PRODUCT:
      if (temp != null) {
        msg = '请添加' + temp;
      } else {
        msg = '请添加品牌';
      }
      // 没有添加按钮  所有添加设置为0
      switch (viewtype) {
        case ViewType.REPORT:
        case ViewType.REPORT_ADD:
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break;
    case ModuleType.ORDER_DEVICE:
      if (temp != null) {
        msg = '请添加' + temp;
      } else {
        msg = '请添加设备';
      }
      switch (viewtype) {
        case ViewType.REPORT:
          addVisble = 0;
          delVisble = 1;
          break;
        case ViewType.REPORT_ADD:
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
        case ViewType.POLLING_ADD:
          addVisble = 1;
          delVisble = 1;
          break;
      }
      break;
    case ModuleType.ORDER_PARTS:
      if (temp != null) {
        msg = '请添加' + temp;
      } else {
        msg = '请添加备件';
      }
      switch (viewtype) {
        case ViewType.REPORT:
          if (baseModuleBean == null || parseInt(baseModuleBean.have) !== 1) {
            addVisble = 0;
            delVisble = 0;
          } else {
            addVisble = 1;
            delVisble = 1;
          }
          break;
        case ViewType.REPORT_ADD:
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break;
    case ModuleType.ORDER_REMARK:
      msg = '请添加备注';
      switch (viewtype) {
        case ViewType.REPORT:
          if (baseModuleBean == null || parseInt(baseModuleBean.have) !== 1) {
            addVisble = 0;
            delVisble = 0;
          } else {
            addVisble = 1;
            delVisble = 1;
          }
          break;
        case ViewType.REPORT_ADD:
          addVisble = 1;
          delVisble = visible;
          break;
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break;
    case ModuleType.ORDER_FIX_SUMMARY:
      msg = '请添加维修小结';
      switch (viewtype) {
        case ViewType.REPORT:
          if (baseModuleBean == null || parseInt(baseModuleBean.have) !== 1) {
            addVisble = 0;
            delVisble = 0;
          } else {
            addVisble = 1;
            delVisble = 1;
          }
          break;
        case ViewType.REPORT_ADD:
          addVisble = 1;
          delVisble = visible;
          break;
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break;
    case ModuleType.ORDER_WORKTIME:
      msg = '请添加工时';
      switch (viewtype) {
        case ViewType.REPORT:
          if (baseModuleBean == null || parseInt(baseModuleBean.have) !== 1) {
            addVisble = 0;
            delVisble = 0;
          } else {
            addVisble = 1;
            delVisble = 1;
          }
          break;
        case ViewType.REPORT_ADD:
          addVisble = 1;
          delVisble = visible;
          break;
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break; 
    case ModuleType.ORDER_FAULTTYPE:
      msg = '请添加故障类型';
      switch (viewtype) {
        case ViewType.REPORT:
          addVisble = 0;
          delVisble = 1;
          break;
        case ViewType.REPORT_ADD:
          addVisble = visible;
          delVisble = 1;
          break;
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break;
    case ModuleType.ORDER_FAULTPHENOMENON:
      msg = '请添加故障现象';
      switch (viewtype) {
        case ViewType.REPORT:
          addVisble = 0;
          delVisble = 1;
          break;
        case ViewType.REPORT_ADD:
          addVisble = visible;
          delVisble = 1;
          break;
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break;
    case ModuleType.ORDER_COST:
      msg = '请添加费用';
      switch (viewtype) {
        case ViewType.REPORT:
          if (baseModuleBean == null || parseInt(baseModuleBean.have) !== 1) {
            addVisble = 0;
            delVisble = 0;
          } else {
            addVisble = 1;
            delVisble = 1;
          }
          break;
        case ViewType.REPORT_ADD:
          addVisble = visible;
          delVisble = 1;
          break;
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break;
    case ModuleType.ORDER_DEAL_IMAGE:
      msg = '请添加照片';
      switch (viewtype) {
        case ViewType.REPORT:
          if (baseModuleBean == null || parseInt(baseModuleBean.have) !== 1) {
            addVisble = 0;
            delVisble = 0;
          } else {
            addVisble = 1;
            delVisble = 1;
          }
          break;
        case ViewType.REPORT_ADD:
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break;
    case ModuleType.ORDER_TAG:
      if (temp != null) {
        msg = '请添加' + temp;
      } else {
        msg = '请添加订单标签';
      }
      switch (viewtype) {
        case ViewType.REPORT:
        case ViewType.REPORT_ADD:
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break;
    case ModuleType.ORDER_DEPARTMENT:
      msg = '请选择服务部门';
      break;
    case ModuleType.ORDER_DIY_ONE:
      msg = '请输入自定义1';
      switch (viewtype) {
        case ViewType.REPORT:
          if (baseModuleBean == null || parseInt(baseModuleBean.have) !== 1) {
            addVisble = 0;
            delVisble = 0;
          } else {
            addVisble = 1;
            delVisble = 1;
          }
          break;
        case ViewType.REPORT_ADD:
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break;
    case ModuleType.ORDER_DIY_TWO:
      msg = '请输入自定义2';
      switch (viewtype) {
        case ViewType.REPORT:
          if (baseModuleBean == null || parseInt(baseModuleBean.have) !== 1) {
            addVisble = 0;
            delVisble = 0;
          } else {
            addVisble = 1;
            delVisble = 1;
          }
          break;
        case ViewType.REPORT_ADD:
        case ViewType.DEAL_TASK:
        case ViewType.DEAL_ORDER:
          addVisble = visible;
          delVisble = visible;
          break;
        case ViewType.DETAIL_ORDER:
        case ViewType.DETAIL_TASK:
        case ViewType.DETAIL_REPORT:
        case ViewType.DEAL_REPORT:
        case ViewType.DETAIL_INSPECTION_ORDER:
        case ViewType.DETAIL_INSPECTION_TASK:
        case ViewType.REPORT_INSPECTION:
          addVisble = 0;
          delVisble = 0;
          break;
      }
      break;
  }
  ViewModel.me = msg;
  ViewModel.av = addVisble;
  ViewModel.dv = delVisble;
  ViewModel.v = visible;
  return ViewModel;
}
export function checkTaskCoordinationVisble(orderType:any, companyId:any) {
  var baseModuleBean = getBaseModelForOrderTypeAppointmentTime(orderType, companyId, ModuleType.ORDER_TASK_COORDINATION);
  if (baseModuleBean != null && parseInt(baseModuleBean.task_cooperate) === 1) {
    return true;
  } else {
    return false;
  }
}
export function checkServerAppointmentTime(orderType:any, companyId:any) {
  var baseModuleBean = getBaseModelForOrderTypeAppointmentTime(orderType, companyId, ModuleType.ORDER_APPOINTMENT_TIME);
  if (baseModuleBean != null && parseInt(baseModuleBean.have) === 1 && parseInt(baseModuleBean
    .fix_config) !== 0 && parseInt(baseModuleBean
    .fix_config) !== 9) {
    return true;
  } else {
    return false;
  }
}

export function checkServerAppointmentTimeIsMust(orderType:any, companyId:any) {
  var baseModuleBean = getBaseModelForOrderTypeAppointmentTime(orderType, companyId, ModuleType.ORDER_APPOINTMENT_TIME);
  if (baseModuleBean != null && parseInt(baseModuleBean.have) === 1 && parseInt(baseModuleBean
    .fix_config) === 2) {
    return true;
  } else {
    return false;
  }
}
export function checkTaskAppointmentTimeIsMust(orderType:any, companyId:any) {
  var baseModuleBean = getBaseModelForOrderTypeAppointmentTime(orderType, companyId, ModuleType.TASK_VISIT);
  if (baseModuleBean != null && parseInt(baseModuleBean.have) === 1 && parseInt(baseModuleBean
    .visittime_config) === 1) {
    return true;
  } else {
    return false;
  }
}
function getBaseModelForOrderTypeAppointmentTime(orderType:any, companyId:any, permission:ModuleType) {
  var baseModuleBean = null;
  switch (parseInt(orderType)) {
    // 其他
    case 1:
      baseModuleBean = getOtherBaseModel(companyId, permission);
      break;
      // 维保
    case 2:
      baseModuleBean = getFixBaseModel(companyId, permission);
      break;
      // 安装
    case 3:
      baseModuleBean = getInstallBaseModel(companyId, permission);
      break;
    case 4:
      baseModuleBean = getPollingBaseModel(companyId, permission);
      break;
  }
  return baseModuleBean;
}

function checkVisibility(baseModuleBean: any, mt: ViewType) {
  if (baseModuleBean == null) {
    return 0;
  }
  if (baseModuleBean.have === 1 && !isConfig0ro9(getConfig(baseModuleBean, mt))) {
    return 1;
  } else {
    return 0;
  }
}

// 1选 2必填 0||9 不显示
function isConfig0ro9(config: any) {
  if (parseInt(config) === 0 || parseInt(config) === 9) {
    return true;
  } else {
    return false;
  }
}

function getConfig(mb: any, mt: ViewType) {
  switch (mt) {
    case ViewType.REPORT:
      return mb.order_config;
    case ViewType.REPORT_ADD:
      return mb.add_order_config;
    case ViewType.DEAL_ORDER:
    case ViewType.DEAL_INSPECTION_ORDER:
      return mb.fix_config;
    case ViewType.DEAL_TASK:
    case ViewType.DEAL_INSPECTION_TASK:
      return mb.task_config;
    case ViewType.DETAIL_ORDER:
    case ViewType.DETAIL_TASK:
      return 0;
    case ViewType.POLLING_ADD:
      return 1;
    default:
      return 0;
  }
}

function getInstallBaseModel(companyId: string, permission: ModuleType) {
  return getModuleForModuleView(getInstallModule(companyId), permission);
}

// 东改 增加导出
export function getFixBaseModel(companyId: string, permission: ModuleType) {
  return getModuleForModuleView(getFixModule(companyId), permission);
}

function getOtherBaseModel(companyId: string, permission: ModuleType) {
  return getModuleForModuleView(getOtherModule(companyId), permission);
}

function getPollingBaseModel(companyId: string, permission: ModuleType) {
  return getModuleForModuleView(getPollingModule(companyId), permission);
}

function check(lsmoduleBean: any, lsmoduleBeanRole: any) {
  var TRUE: number = 1;
}

function checkPermissionDetail(moduleBean: any, moduleBeanRole: any, permission: Type) {
  var r: boolean = false;
  var TRUE: number = 1;
  var lsmoduleBean = getModule(moduleBean, permission);
  var lsmoduleBeanRole = getModule(moduleBeanRole, permission);
  if (lsmoduleBean != null && lsmoduleBeanRole != null) {
    r = lsmoduleBean.have === TRUE && lsmoduleBeanRole.have === TRUE;
  } else {
    r = false;
  }
  return r;
}

function checkPermissionSingDetail(moduleBean: any, permission: Type) {
  var r: boolean = false;
  var TRUE: number = 1;
  var lsmoduleBean = getModule(moduleBean, permission);
  if (lsmoduleBean != null) {
    r = lsmoduleBean.have === TRUE;
  } else {
    r = false;
  }
  return r;
}

function getModule(moduleBean: any, permission: Type) {
  if (!moduleBean || moduleBean === null) {
    return null;
  }
  var module: any = null;
  switch (permission) {
    case Type.MyOrder:
      module = moduleBean.ls100000;
      break
    case Type.REPORT_ORDER_LOOK:
      module = moduleBean.ls120000;
      break;
    case Type.REPORT_COMPANY_LOOK:
      module = moduleBean.ls121000;
      break;
    case Type.REPORT_DEPT_LOOK:
      module = moduleBean.ls122000;
      break;
    case Type.REPORT_DEPT_LOOK_SUB:
      module = moduleBean.ls122100;
      break;
    case Type.REPORT_FOR_BRANCH_OFFICE:
      module = moduleBean.ls405000;
      break;
    case Type.SERVICER_MODULE:
      module = moduleBean.ls150000;
      break;
    case Type.REPORT_CREAT:
      module = moduleBean.ls102000;
      break;
    case Type.REPORT_LOOK:
      module = moduleBean.ls101000;
      break;
    case Type.ORDER_ADD:
      module = moduleBean.ls152000;
      break;
    case Type.MyAddOrders:
      module = moduleBean.ls151050;
      break;
    case Type.ORDER_LOOK:
      module = moduleBean.ls151000;
      break;
    case Type.ServerOrderOutSource:
      module = moduleBean.ls220000;
      break;
    case Type.ORDER_DEAL:
      module = moduleBean.ls153000;
      break;
    case Type.ORDER_ASSIGN_SELF:
      module = moduleBean.ls153010;
      break;
    case Type.ORDER_ASSIGN:
      module = moduleBean.ls153020;
      break;
    case Type.ORDER_ASSIGN_DEPT:
      module = moduleBean.ls153021;
      break;
    case Type.ORDER_ASSIGN_ENGINEER:
      module = moduleBean.ls153023;
      break;

    case Type.ORDER_TRANSFER:
      module = moduleBean.ls153030;
      break;
    case Type.OrderEnquiry:
      module = moduleBean.ls740000;
      break;
    case Type.ORDER_CONFIRM_CUSTOMER:
      module = moduleBean.ls153040;
      break;
    case Type.ORDER_ADD_BRAND:
      module = moduleBean.ls301000;
      break;
    case Type.ProductAuth:
      module = moduleBean.ls304000;
      break;
    case Type.ProductAuthSer:
      module = moduleBean.ls305000;
      break;
    case Type.OrderTask:
      module = moduleBean.ls200000;
      break;
    case Type.TASK_LOOK:
      module = moduleBean.ls201000;
      break;
    case Type.TASK_DEAL:
      module = moduleBean.ls202000;
      break;
    case Type.TASK_SONGXIU:
      module = moduleBean.ls202070;
      break;
    case Type.TASK_REMOTE:
      module = moduleBean.ls202010;
      break;
    case Type.TASK_VISIT:
      module = moduleBean.ls202020;
      break;
    case Type.TASK_SEND:
      module = moduleBean.ls202030;
      break;
    case Type.TASK_TRANSFER:
      module = moduleBean.ls202040;
      break;
    case Type.TASK_COORDINATION:
      module = moduleBean.ls202050;
      break;
    case Type.TASK_APPEAR:
      module = moduleBean.ls202100;
      break;
    case Type.ELECTRONIC:
      module = moduleBean.ls450000;
      break;
    case Type.CUSTOMER_ELECTRONIC:
      module = moduleBean.ls452000;
      break;
    case Type.KPI:
      module = moduleBean.ls530000;
      break;
    case Type.KPISETTING:
      module = moduleBean.ls531000;
      break;
    case Type.STATISTICS:
      module = moduleBean.ls550000;
      break;
    case Type.StatisticsPerson:
      module = moduleBean.ls551000;
      break;
    case Type.StatisticsCusOrder:
      module = moduleBean.ls552000;
      break;
    case Type.StatisticsDiyOrder:
      module = moduleBean.ls553000;
      break;
    case Type.StatisticsSerDeptDiyOrder:
      module = moduleBean.ls553100;
      break;
    case Type.StatisticsBigData:
      module = moduleBean.ls554000;
      break;
    case Type.StatisticsServer:
      module = moduleBean.ls555000;
      break;
    case Type.StatisticsCusDiyOrder:
      module = moduleBean.ls556000;
      break;
    case Type.StatisticsDevice:
      module = moduleBean.ls557000;
      break;
    case Type.StatisticsFaultPhenomenon:
      module = moduleBean.ls558100;
      break;
    case Type.StatisticsFaultType:
      module = moduleBean.ls558200;
      break;
    case Type.StatisticsAddress:
      module = moduleBean.ls558300;
      break;
    
    case Type.StatisticsParts:
      module = moduleBean.ls559100;
      break;
    case Type.StatisticsDeptCusOrder:
      module = moduleBean.ls551500;
      break;
    case Type.StatisticsDeptSerOrder:
      module = moduleBean.ls551600;
      break;
    case Type.StatisticsDeptSerOrderWorkTime:
      module = moduleBean.ls551810;
      break;
    case Type.StatisticsCusPrice:
      module = moduleBean.ls552100;
      break;
    case Type.StatisticsDeptCusPrice:
      module = moduleBean.ls551100;
      break;
    case Type.StatisticsDeptSerPrice:
      module = moduleBean.ls551200;
      break;
    case Type.Settlement:
      module = moduleBean.ls156000;
      break;
    case Type.SettlementDeal:
      module = moduleBean.ls156300;
      break;
    case Type.CUSTOMER_COMPANY:
      module = moduleBean.ls650000;
      break;
    case Type.CustomerAliasGroup:
      module = moduleBean.ls651000;
      break;
    case Type.SERVICE_COMPANY:
      module = moduleBean.ls700000;
      break;
    //code全判断
    case Type.SERVICER_COMPANY:
      module = moduleBean.ls700000;
      break;
    case Type.TASK_VISIT_MUST:
      module = moduleBean.ls2020200;
      break;
    case Type.TASK_VISIT_TIME_MUST:
      module = moduleBean.ls20202002;
      break;
    case Type.PRODUCT_SCAN:
      module = moduleBean.ls303000;
      break;
    case Type.COMPANY_SETTING:
      module = moduleBean.ls601000;
      break;
    case Type.EORDER_POLLING:
      module = moduleBean.ls160000;
      break;
    case Type.PollingOrderList:
      module = moduleBean.ls161000;
      break;
    case Type.PollingOrderEven:
      module = moduleBean.ls162000;
      break;
    case Type.PollingOrderCheck:
      module = moduleBean.ls163000;
      break;
    case Type.PollingOrderAddOnce:
      module = moduleBean.ls164000;
      break;
    case Type.PollingOrderSeting:
      module = moduleBean.ls169000;
      break;
    case Type.ComplaintOrder:
      module = moduleBean.ls170000;
      break;
    case Type.ORDER_COMPLAINT_LOOK:
      module = moduleBean.ls171000;
      break;
    case Type.ORDER_COMPLAINT_DEAL:
      module = moduleBean.ls172000;
      break;
    case Type.ORDER_BBS_LOOK:
      module = moduleBean.ls173000;
      break;
    case Type.DEPARTMENT:
      module = moduleBean.ls940000;
      break;
    case Type.ORDER_HANDUP:
      module = moduleBean.ls153050;
      break;
    case Type.ORDER_CLOSE:
      module = moduleBean.ls153090;
      break;
    case Type.ORDER_ROB_LOOK:
      module = moduleBean.ls151030;
      break;
    case Type.ORDER_LOOK_COM:
      module = moduleBean.ls151010;
      break;
    case Type.IsSelfTask:
      module = moduleBean.ls153011;
      break;
    case Type.ORDER_LOOK_DEP:
      module = moduleBean.ls151020;
      break;
    case Type.ORDER_ROB_DEAL:
      module = moduleBean.ls153060;
      break;
    case Type.ROLE_USER:
    case Type.Staff:
      module = moduleBean.ls250000;
      break;
    case Type.StaffALL:
      module = moduleBean.ls251000;
      break;
    case Type.StaffRole:
      module = moduleBean.ls252000;
      break;
    case Type.StaffDepatment:
      module = moduleBean.ls253000;
      break;
    case Type.StaffAutoAssign:
      module = moduleBean.ls390000;
      break;
    case Type.StaffScheduling:
      module = moduleBean.ls255000;
      break;
    case Type.INQUIRY:
      module = moduleBean.ls730000;
      break;
    case Type.VISITOR:
      module = moduleBean.ls832000;
      break;
    case Type.TASK_PAUSE:
      module = moduleBean.ls202060;
      break;

    case Type.PunchTheClockRecord:
      module = moduleBean.ls261000;
      break;
    case Type.PunchTheClockSetting:
      module = moduleBean.ls262000;
      break;
    case Type.PunchTheClock:
    case Type.PUNCH_THE_CLOCK:
      module = moduleBean.ls254000;
      break;
    case Type.ORDER_CHECK:
      module = moduleBean.ls131000;
      break;
    case Type.MyOrderCheckOrder:
      module = moduleBean.ls132000;
      break;
    case Type.CheckManigerSetting:
      module = moduleBean.ls133000;
      break;
    case Type.FOLLOW_ORDER:
      module = moduleBean.ls713000;
      break;
    case Type.BRANCH_ORDER:
      module = moduleBean.ls400000;
      break;
    case Type.BRANCH_ORDER_REPORT:
      module = moduleBean.ls401000;
      break;
    case Type.BRANCH_ORDER_SERVER:
      module = moduleBean.ls402000;
      break;
    case Type.ORDER_VIDEO_CALL:
      module = moduleBean.ls880000;
      break;
    case Type.ORDER_REPORT_DEPT:
      module = moduleBean.ls140000;
      break;
    case Type.CHECKPOINT:
      module = moduleBean.ls180000;
      break;
    case Type.HOME_REPAIR:
      module = moduleBean.ls912000;
      break;
    case Type.fault:
      module = moduleBean.ls750000;
      break;
    case Type.device:
      module = moduleBean.ls302000;
      break;
    case Type.parts:
      module = moduleBean.ls350000;
      break;
    // case Type.HOME_SERVICE:
    //   module = moduleBean.ls913000;
    //   break;
    // case Type.HOME_ENGINNER:
    //   module = moduleBean.ls914000;
    //   break;
    case Type.HOME_MAP:
      module = moduleBean.ls900000;
      break;
    case Type.ORDER_WORK_SHEET:
      module = moduleBean.ls450000;
      break;
    case Type.InstallModule:
      module = moduleBean.ls230000;
      break;
    case Type.InstallAdd:
      module = moduleBean.ls231000;
      break;
    case Type.InstallSource:
      module = moduleBean.ls232000;
      break;
    case Type.InstallSetting:
      module = moduleBean.ls239000;
      break;
    case Type.OrderInstallAplay:
      module = moduleBean.ls240000;
      break;
    case Type.OrderInstallAplayAdd:
      module = moduleBean.ls241000;
      break;
    case Type.OtherOpen:
      module = moduleBean.ls111000;
      break;
    case Type.DingDingAuth:
      module = moduleBean.ls840000;
      break;
    case Type.WXAuth:
      module = moduleBean.ls800000;
      break;
    case Type.GZHuth:
      module = moduleBean.ls820000;
      break;

    case Type.pca:
      module = moduleBean.ls990000;
      break;
    case Type.tag:
      module = moduleBean.ls603000;
      break;
    case Type.FAULT_PHENOMENON:
      module = moduleBean.ls615000;
      break;
    case Type.myselfPCALs:
      module = moduleBean.ls920000;
      break;
    case Type.CheckSettingCompany:
      module = moduleBean.ls134000;
      break;
    case Type.CheckSettingDept:
      module = moduleBean.ls135000;
      break;
    case Type.CheckSettingGroup:
      module = moduleBean.ls136000;
      break;
    case Type.Stock:
      module = moduleBean.ls360000;
      break;
    case Type.StockTz:
      module = moduleBean.ls361000;
      break;
    case Type.StockCheck:
      module = moduleBean.ls362000;
      break;
    case Type.StockInOutRecord:
      module = moduleBean.ls364000;
      break;
    case Type.Stocksetting:
      module = moduleBean.ls365000;
      break;
    case Type.StockApplyInoutRecord:
      module = moduleBean.ls368300;
      break;
    case Type.Device:
      module = moduleBean.ls300000;
      break;

    case Type.workOrderNum:
      module = moduleBean.ls860000;
      break;
    case Type.BJD:
      module = moduleBean.ls730000;
      break;
    case Type.TASK_CLOSE:
      module = moduleBean.ls153055;
      break;
    case Type.SP:
      module = moduleBean.ls256000;
      break;
    case Type.GroupPush:
      module = moduleBean.ls380000;
      break;
    case Type.GroupPushAddress:
      module = moduleBean.ls381000;
      break;
    case Type.GroupPushCustomer:
      module = moduleBean.ls382000;
      break;
    case Type.GroupPushFault:
      module = moduleBean.ls383000;
      break;
    case Type.GroupPushTags:
      module = moduleBean.ls384000;
      break;
    case Type.GroupPushCombine:
      module = moduleBean.ls385000;
      break;
    case Type.GroupPushCustomerDept:
      module = moduleBean.ls386000;
      break;
    case Type.contentUser:
      module = moduleBean.ls893100;
      break;
    case Type.contentUserMobile:
      module = moduleBean.ls893200;
      break;
    case Type.contentUserPhone:
      module = moduleBean.ls893300;
      break;
    case Type.Description:
      module = moduleBean.ls892000;
      break;
    case Type.SN:
      module = moduleBean.ls897100;
      break;
    case Type.Schedulings:
      module = moduleBean.ls255000;
      break;
    case Type.RelatedModule:
      module = moduleBean.ls670000;
      break;
    case Type.CustomerRelationRelation:
      module = moduleBean.ls670010;
      break;
    case Type.CustomerRelationRelationOrder:
      module = moduleBean.ls670050;
      break;
    case Type.CustomerHistry:
      module = moduleBean.ls155010;
      break;
    case Type.DeviceHistry:
      module = moduleBean.ls155000;
      break;
    case Type.CloseOrder:
      module = moduleBean.ls125100;
      break;
    case Type.FinishOrder:
      module = moduleBean.ls125400;
      break;
    case Type.InsteadCheckPass:
      module = moduleBean.ls125600;
      break;
    case Type.OrderEvaluate:
      module = moduleBean.ls125800;
      break;
    case Type.TaskTrack:
      module = moduleBean.ls270000;
      break;
    case Type.PersonStock:
      module = moduleBean.ls367000;
      break;
    case Type.TemplateDIY:
      module = moduleBean.ls851000;
      break;
    case Type.OrederCheck:
      module = moduleBean.ls130000;
      break;
    case Type.BranchCompany:
      module = moduleBean.ls400000;
      break;
    case Type.BruanchOrderCusGroup:
      module = moduleBean.ls406000;
      break;
    case Type.BruanchOrderCusOrder:
      module = moduleBean.ls401000;
      break;
    case Type.BranchOrderServicer:
      module = moduleBean.ls404000;
      break;
    case Type.BruanchOrderDayCheck:
      module = moduleBean.ls403000;
      break;
    case Type.CompanyNotice:
      module = moduleBean.ls570000;
      break;
    case Type.CompanyNoticeInner:
      module = moduleBean.ls572000;
      break;
    case Type.CompanyCustomerNotice:
      module = moduleBean.ls571000;
      break;
    case Type.Project:
      module = moduleBean.ls660000;
      break;
    case Type.ProjectSeting:
      module = moduleBean.ls661030;
      break;

    case Type.ProjectCreate:
      module = moduleBean.ls661200;
      break;
    case Type.ProjectAll:
      module = moduleBean.ls661100;
      break;
    case Type.ProjectMy:
    case Type.ProjectRecycle:
      module = moduleBean.ls663100;
      break;
    case Type.PauseTask:
      module = moduleBean.ls202060;
      break;
    case Type.WordFile:
      module = moduleBean.ls894100;
      break;
    case Type.Knowledge:
      module = moduleBean.ls480000;
      break;
    case Type.KnowledgeSetting:
      module = moduleBean.ls481000;
      break;
    case Type.KnowledgeLook:
      module = moduleBean.ls482000;
      break;
    case Type.Template:
      module = moduleBean.ls610000;
      break
    case Type.TemplateDiyField:
      module = moduleBean.ls853000;
      break
    case Type.TemplateRepair:
      module = moduleBean.ls851000;
      break
    case Type.TemplateOrder:
      module = moduleBean.ls631100;
      break
    case Type.TemplateTroubleDescribleTags:
      module = moduleBean.ls611000;
      break
    case Type.TemplateImageTags:
      module = moduleBean.ls613000;
      break
    case Type.TemplateRemarkTags:
      module = moduleBean.ls614000;
      break
    case Type.TemplateEvaluateTags:
      module = moduleBean.ls607000;
      break
    case Type.TemplateEvaluateCustomer:
      module = moduleBean.ls618000;
        break
    case Type.TemplateAddedProgressTags:
      module = moduleBean.ls612000;
      break
    case Type.TemplateAplayReason:
      module = moduleBean.ls616000;
      break
    case Type.TemplateQuestionBank:
      module = moduleBean.ls617000;
      break
    case Type.price:
      module = moduleBean.ls500000;
      break
    case Type.TemplateWorkTime:
      module = moduleBean.ls896500;
      break
    case Type.System:
      module = moduleBean.ls600000;
      break
    case Type.SystemCompany:
      module = moduleBean.ls601000;
      break
    case Type.SystemModule:
      module = moduleBean.ls602000;
      break
    case Type.SystemOrderSetting:
      module = moduleBean.ls604000;
      break
    case Type.SystemOperationLog:
      module = moduleBean.ls606000;
      break
    case Type.ServerIndex:
      module = moduleBean.ls605000;
      break
  }
  return module;
}

function getModuleForModuleView(moduleBean: any, permission: ModuleType) {
  if (!moduleBean || moduleBean === null) {
    return null;
  }
  var module: any = null;
  switch (permission) {
    case ModuleType.ORDER_IMAGE:
    case ModuleType.ORDER_DEAL_IMAGE:
      module = moduleBean.ls960000;
      break;
    case ModuleType.ORDER_VIDEO:
    case ModuleType.ORDER_DEAL_VIDEO:
      module = moduleBean.ls970000;
      break;
    case ModuleType.ORDER_AUDIO:
      module = moduleBean.ls950000;
      break;
    case ModuleType.ORDER_TAG:
      module = moduleBean.ls603000;
      break;
    case ModuleType.ORDER_FAULTTYPE:
      module = moduleBean.ls750000;
      break;
    case ModuleType.ORDER_FAULTPHENOMENON:
      module = moduleBean.ls615000;
      break;
    case ModuleType.ORDER_PRODUCT:
      module = moduleBean.ls301000;
      break;
    case ModuleType.ORDER_DEVICE:
      module = moduleBean.ls302000;
      break;
    case ModuleType.ORDER_REMARK:
      module = moduleBean.ls980000;
      break;
    case ModuleType.ORDER_FIX_SUMMARY:
      module = moduleBean.ls896400;
      break;
    case ModuleType.ORDER_WORKTIME:
      module = moduleBean.ls896500;
      break;
    case ModuleType.ORDER_PARTS:
      module = moduleBean.ls350000;
      break;
    case ModuleType.ORDER_COST:
      module = moduleBean.ls500000;
      break;
    case ModuleType.ORDER_ADDRESS:
      module = moduleBean.ls990000;
      break;
    case ModuleType.TASK_VISIT:
      module = moduleBean.ls202020;
      break;
    case ModuleType.ORDER_DEPARTMENT:
      module = moduleBean.ls940000;
      break;
    case ModuleType.ORDER_APPOINTMENT_TIME:
      module = moduleBean.ls930000;
      break;
    case ModuleType.ORDER_CUSTOM_ADDRESS:
      module = moduleBean.ls920000;
      break;
    case ModuleType.ORDER_REPORT_ADDRESS_DETAIL:
      module = moduleBean.ls891000;
      break;
    case ModuleType.ORDER_SN:
      module = moduleBean.ls897100;
      break;
    case ModuleType.ORDER_DIY_ONE:
      module = moduleBean.ls895100;
      break;
    case ModuleType.ORDER_DIY_TWO:
      module = moduleBean.ls895200;
      break;
    case ModuleType.ORDER_WORD_FILE:
      module = moduleBean.ls894100;
      break;
    case ModuleType.ORDER_TASK_COORDINATION:
      module = moduleBean.ls153020;
      break;
  }
  return module;
}

function getModuleUserOrCompany(companyId: string) {
  if (companyId && parseInt(companyId) !== 0) {
    var c: any = null;
    var companyList = UserModule.getCompanyList;
    for (var company of companyList) {
      if ((company as any).id === companyId) {
        c = company;
      }
    }
    if (c) {
      if (parseInt(c.relation_status) !== 1) {
        return null;
      } else {
        return c.module;
      }
    } else {
      return null;
    }
  } else {
    if (UserModule.user == null || (UserModule.user as any).module == null) {
      return null;
    } else {
      return (UserModule.user as any).module;
    }
  }
}

function getModuleUserOrRole(companyId: string) {
  if (companyId === undefined || companyId == null || parseInt(companyId) === 0) {
    if (UserModule.user == null || (UserModule.user as any).module == null) {
      return null;
    } else {
      return (UserModule.user as any).module;
    }
  } else {
    var c: any = null;
    var companyList = UserModule.getCompanyList;
    for (var company of companyList) {
      if ((company as any).id === companyId) {
        c = company;
      }
    }
    if (c === undefined || c == null || c.role === undefined || c.role.module == null) {
      return null;
    } else {
      if (parseInt(c.relation_status) !== 1) { // 东改 relation_status是 string
        return null;
      } else {
        return c.role.module;
      }
    }
  }
}

function getOtherModule(companyId: string) {
  if (companyId && parseInt(companyId) !== 0) {
    var c: any = null;
    var companyList = UserModule.getCompanyList;
    for (var company of companyList) {
      if ((company as any).id === companyId) {
        c = company;
      }
    }
    if (c) {
      if (parseInt(c.relation_status) !== 1) {
        return null;
      } else {
        return c.other_module;
      }
    } else {
      return null;
    }
  } else {
    return null;
  }
}

function getFixModule(companyId: string) {
  if (companyId && parseInt(companyId) !== 0) {
    var c: any = null;
    var companyList = UserModule.getCompanyList;
    for (var company of companyList) {
      if ((company as any).id === companyId) {
        c = company;
      }
    }
    if (c) {
      if (parseInt(c.relation_status) !== 1) {
        return null;
      } else {
        return c.fix_module;
      }
    } else {
      return null;
    }
  } else {
    return null;
  }
}

function getInstallModule(companyId: string) {
  if (companyId && parseInt(companyId) !== 0) {
    var c: any = null;
    var companyList = UserModule.getCompanyList;
    for (var company of companyList) {
      if ((company as any).id === companyId) {
        c = company;
      }
    }
    if (c) {
      if (parseInt(c.relation_status) !== 1) {
        return null;
      } else {
        return c.install_module;
      }
    } else {
      return null;
    }
  } else {
    return null;
  }
}

function getPollingModule(companyId: string) {
  if (companyId && parseInt(companyId) !== 0) {
    var c: any = null;
    var companyList = UserModule.getCompanyList;
    for (var company of companyList) {
      if ((company as any).id === companyId) {
        c = company;
      }
    }
    if (c) {
      if (parseInt(c.relation_status) !== 1) {
        return null;
      } else {
        return c.polling_check;
      }
    } else {
      return null;
    }
  } else {
    return null;
  }
}
